module.exports = __webpack_public_path__ + "img/Logo_TestVocacional.ad4c6afa.png";